import { render, staticRenderFns } from "./schedule-item.vue?vue&type=template&id=6dd808f2&scoped=true"
import script from "./schedule-item.vue?vue&type=script&lang=js"
export * from "./schedule-item.vue?vue&type=script&lang=js"
import style0 from "./schedule-item.vue?vue&type=style&index=0&id=6dd808f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd808f2",
  null
  
)

export default component.exports